import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { UserService } from 'app/services/user.service';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss'],
    standalone: false
})
export class LogoutComponent implements OnInit {

    constructor(private userService: UserService,
        private router: Router) { }

    ngOnInit() {
        this.userService.logout();
        this.router.navigate(['/']);
    }
}
 